export default "__VITE_ASSET__BzbSfNd3__"